/* eslint-disable import/no-unresolved */
import { ptBR } from "date-fns/locale";
import { useEffect, useState } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/style.css";
import classNames from "react-day-picker/style.module.css";

import { HTTPErrorCallback } from "Helpers/Error";
import moment from "Helpers/MomentCompat";

import UseServices from "Hooks/UseServices";

import * as S from "./styles";

const ProjectsCalendar = ({ setShowCalendar }) => {
  const { api } = UseServices();

  const [dates, setDates] = useState([]);
  const [calendar, setCalendar] = useState([]);
  // Faixas de dias em que o projeto acontece (project_start_at → finish_at),
  // prontas do backend. O calendário destaca todos os dias do intervalo, não só
  // os marcos de início e fim.
  const [projectRanges, setProjectRanges] = useState([]);

  // const [currentMonth, setCurrentMonth] = useState(moment().month());
  const [selectedDay, setSelectedDay] = useState(null);

  useEffect(() => {
    getCalendar();
  }, []);

  const getCalendar = () => {
    api
      .get("/projects/calendars")
      .then((response) => {
        const dates = response.data?.all_dates;
        const calendar = response.data?.calendar;

        setDates(dates);
        setCalendar(calendar.map((date) => new Date(date)));
        setProjectRanges(
          (response.data?.project_ranges || []).map((range) => ({
            from: new Date(range.from),
            to: new Date(range.to),
          })),
        );

        if (!dates.length || !calendar.length) setShowCalendar(false);
      })
      .catch((error) => {
        return HTTPErrorCallback(error);
      });
  };

  const today = moment();

  return (
    <S.Wrapper>
      <S.Infos>
        <S.Today>
          <span>
            {Intl.DateTimeFormat("pt-BR", {
              weekday: "long",
            }).format(new Date())}
          </span>

          <h1>{today.format("DD/MM")}</h1>
        </S.Today>

        {!dates.length ? <span>Nenhuma data cadastrada.</span> : null}

        <S.Dates>
          {dates
            // .filter((date) => moment(date.date).month() === currentMonth)
            .map((date, i) => (
              <S.Date
                key={i}
                active={
                  selectedDay &&
                  moment(selectedDay).format("DD/MM/YYYY") ===
                    moment(date.date).format("DD/MM/YYYY")
                }
              >
                <S.DateMain>
                  {/* Link de verdade (não onClick): permite Ctrl/Cmd+clique e
                      abrir em nova aba. Destino é a aba da carteira, onde
                      vivem os projetos aportados que o calendário mostra.

                      ⚠️ SEM `title`: em link com texto, o tooltip vira o NOME
                      ACESSÍVEL e substitui o nome do projeto para o leitor de
                      tela (mesma armadilha documentada no AI_CONTEXT do front). */}
                  {date.project_id ? (
                    <S.ProjectLink
                      href={`/list-projects?project_id=${date.project_id}&tab=list`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {date.project_name}
                    </S.ProjectLink>
                  ) : (
                    <span>{date.project_name}</span>
                  )}
                  <h3>{date.date_name}</h3>
                </S.DateMain>
                <p>{moment(date.date).format("DD/MM/YYYY")}</p>
              </S.Date>
            ))}
        </S.Dates>
      </S.Infos>

      <S.Calendar>
        <DayPicker
          mode="multiple"
          selected={calendar}
          onDayClick={(e) => {
            setSelectedDay(e);
          }}
          // onMonthChange={(e) => {
          //   setCurrentMonth(moment(e).month());
          // }}
          min={calendar.length}
          max={calendar.length}
          disabled={[calendar]}
          // Faixa do projeto: pinta todos os dias do intervalo. Os marcos
          // (`selected`) continuam com o círculo verde por cima.
          modifiers={{ in_project: projectRanges }}
          modifiersClassNames={{ in_project: "in_project" }}
          locale={ptBR}
          classNames={{
            ...classNames,
            months: "months",
            month: "month",
            selected: "selected",
            day: "day",
            day_button: "day_button",
            today: "today",
            weekdays: "weekdays",
            weekday: "weekday",
            button_next: "button_next",
            button_previous: "button_previous",
            caption_label: "caption_label",
            month_caption: "month_caption",
            nav: "nav",
          }}
        />
      </S.Calendar>
    </S.Wrapper>
  );
};

export default ProjectsCalendar;
